import { toPng } from 'html-to-image';

/**
 * 构建 AETERNA 品牌水印 Footer
 * 使用内联样式确保渲染时样式不丢失
 */
function buildBrandFooter(): HTMLElement {
  const footer = document.createElement('div');
  footer.style.padding = '20px';
  footer.style.background = '#f7f5f0';
  footer.style.borderTop = '1px solid rgba(28, 25, 23, 0.08)';
  footer.style.textAlign = 'center';

  const brandName = document.createElement('div');
  brandName.textContent = 'AETERNA';
  brandName.style.fontSize = '16px';
  brandName.style.fontWeight = '300';
  brandName.style.letterSpacing = '0.12em';
  brandName.style.color = '#2c2a29';
  brandName.style.fontFamily = "'Noto Serif SC', 'Source Han Serif SC', serif";
  brandName.style.lineHeight = '1.4';

  const brandTagline = document.createElement('div');
  brandTagline.textContent = '观复知常 · 长寿科学健康平台';
  brandTagline.style.fontSize = '11px';
  brandTagline.style.letterSpacing = '0.1em';
  brandTagline.style.color = '#7a7571';
  brandTagline.style.marginTop = '4px';
  brandTagline.style.fontFamily = "'Noto Serif SC', serif";
  brandTagline.style.lineHeight = '1.4';

  footer.appendChild(brandName);
  footer.appendChild(brandTagline);

  return footer;
}

export async function saveMessageAsImage(
  element: HTMLElement,
  filename?: string
): Promise<boolean> {
  const hiddenElements: HTMLElement[] = [];
  let footer: HTMLElement | null = null;
  try {
    // 隐藏不需要出现在分享图中的元素（如时间戳）
    element.querySelectorAll('[data-export-hide]').forEach((el) => {
      const htmlEl = el as HTMLElement;
      if (htmlEl.style.display !== 'none') {
        htmlEl.style.display = 'none';
        hiddenElements.push(htmlEl);
      }
    });

    // 临时将品牌 Footer 追加到消息元素末尾，截图后再移除
    // 这样避免屏幕外渲染导致 html-to-image 无法正确捕获内容
    footer = buildBrandFooter();
    element.appendChild(footer);

    const dataUrl = await toPng(element, {
      pixelRatio: 2,
      backgroundColor: '#f7f5f0',
    });

    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = filename || 'message.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  } catch {
    return false;
  } finally {
    if (footer && footer.parentNode === element) {
      element.removeChild(footer);
    }
    hiddenElements.forEach((el) => {
      el.style.display = '';
    });
  }
}
